interface FAQmodel {
  question: string;
  answer: {
    title: string;
    content: string[];
  };
}

export const faqs: FAQmodel[] = [
  {
    question: "보건일지를 왜 무료로 제공하나요?",
    answer: {
      title: "보건일지는 무료여야만 합니다.",
      content: [
        "우리는 매일같이 구글, 네이버 등을 사용하며 편리함을 느끼지만, 왜 무료인지에 대한 의문을 갖지 않습니다. 하지만 구글, 네이버는 훌륭한 웹서비스를 바탕으로 세상을 바꿔왔습니다.",
        "물론 좋은 업무프로그램 하나가 세상을 전부 바꿀 수는 없습니다. 하지만 자라나는 꿈나무인 학생들의 건강관리에 있어, 최전선에 계신 보건교사분들의 업무 효율 증진은 세상을 바꿀 수 있는 아주 쉬운 방법일지도 모릅니다. 그래서 보건일지는 무료여야만 합니다.",
        "보건교사를 아내로 둔 팀원의 제안으로 시작한 스마일보건은, 최대한 많은 보건 교사분들께 혜택을 공유하고자 합니다. 대신 보건일지를 무료로 안정적으로 서비스하기 위하여 [스마일몰]을 통해 보건실에 필요한 의약품 등 보건실 용품을 구매할 수 있는 온라인 쇼핑몰을 운영하고 있습니다. 스마일보건과 스마일몰에 대한 많은 보건교사분들의 관심과 성원으로 세상을 바꿀 수 있습니다. 감사합니다.",
      ],
    },
  },
  {
    question: "기존 보건일지에 비해서 무엇이 좋은가요?",
    answer: {
      title: "스마일보건은 기존 프로그램 대비, 5가지 강점이 있습니다.",
      content: [
        "1. 보안이 우수합니다.",
        "개인이 구축하는 PC방호벽은 더 이상 안전하지 않습니다. 스마일보건은 전 세계 수많은 기업의 활용사례에서 검증된 기술로 개인정보를 안전하게 지켜냅니다.",
        "2. 올인원 서비스입니다.",
        "기존에 문서 프로그램으로 별도 정리하시던 요보호 설문, 학생건강상담, 학부모 심층 면담 등을 모두 프로그램 안에 담았습니다.",
        "3. 유저 친화적입니다.",
        "많은 입력이 필요하지 않습니다. 간단한 클릭 몇번으로 번거로운 일들을 쉽고 빠르게 해결할 수 있습니다. 또한 깔끔한 디자인으로 사용성을 높였습니다.",
        "4. 기다릴 필요가 없습니다.",
        "이용 중 궁금한 사항을 즉각적으로 해결할 수 있는 상담톡도 준비되어 있어 실시간으로 문제를 즉각 해결할 수 있습니다.",
        "5. 이제 선생님은 자유롭습니다.",
        "언제 어디서든, 어떤 기기에서든 인터넷 환경에서는 업무가 가능합니다. 업무용PC가 고장 나더라도 걱정하지 않으셔도 됩니다. 데이터를 옮기느랴 고생하지 않으셔도 됩니다. 스마일보건에서 선생님은 자유롭게 업무를 보실 수 있습니다.",
      ],
    },
  },
  {
    question:
      "스마일보건은 학생들의 치료 정보를 왜 Web 서버에 저장을 하는 것인가요?",
    answer: {
      title: "하드디스크는 위험에 노출되어 있습니다.",
      content: [
        "취약한 버전의 운영체제나 소프트웨어가 설치된 PC를 이용할 경우, 웹 서핑 또는 이메일의 첨부 파일이나 링크를 통한 악성코드 감염에 노출될 가능성이 높습니다.",
        "그렇다고 개인이 PC의 보안을 지키는 것은 그 방도의 한계가 있습니다. 이에 전문 보안 기술과 정책이 적용된 Web Server가 해답이 될 수 있습니다.",
        "스마일보건은 기존에 하드디스크에 저장되던 정보를 공공기관 전용 네이버 클라우드를 활용하여, 선생님들께서 안전하게 관리하실 수 있도록 하였습니다.",
      ],
    },
  },
  {
    question: "학생들의 정보를 스마일보건이 마음대로 쓸까봐 걱정되요.",
    answer: {
      title:
        "스마일보건은 웹 서버의 데이터를 화면에 효율적으로 보여주는 역할을 합니다.",
      content: [
        "암호화된 데이터는 인증된 사용자만이 접근할 수 있습니다. 각 학교 별로 저장된 데이터는 인증받은 선생님만이 접근 가능합니다.",
        "스마일보건은 선생님의 요청을 웹 서버에 전달하고 이를 업무에 효율적인 방향으로 선생님의 화면에 전달하는 역할을 합니다.",
        "또한, 의료데이터는 법적으로 보호 받고 있습니다.",
        "의료법 18조와 의료법 23조에서는 의료 데이터를 다루는 업체가 환자 정보를 제대로 지키지 못할 시, 징역 5년 또는 5천만원 이하의 벌금을 부과 받게 되어 있습니다.",
        "스마일보건은 보건교사의 업무 효율 증진을 목표로 하며 법규를 준수합니다.",
      ],
    },
  },
  {
    question: "학생들의 정보는 어떻게 지켜지나요?",
    answer: {
      title: "인증된 사용자만이 데이터에 접근할 수 있습니다.",
      content: [
        "암호화된 데이터는 인증된 사용자만이 접근할 수 있습니다. 각 학교 별로 저장된 데이터는 인증받은 선생님만이 접근 가능합니다.",
        "학생들의 개인정보들은 선생님의 입력이 끝남과 동시에 암호화 과정을 거쳐 난수로 저장 됩니다.",
        "선생님이 해당 정보를 불러올 때만(서버에 요청할 때만) 해독하여 불러오게 됩니다.",
      ],
    },
  },
  {
    question: "시스템 시작 시, 왜 화면이 바로 안나오고 무엇을 로딩하는건가요?",
    answer: {
      title: "계정에 매칭된, 암호화된 데이터를 해독하는 과정입니다.",
      content: [
        "인증절차를 통과한 후, 계정에 매칭된 암호화된 데이터를 불러오고 이를 해독하여 사용자가 인지할 수 있는 데이터로 변환하는 과정입니다.",
        "보다 안전한 데이터 관리를 위한 필수 절차이오니, 선생님의 많은 양해 부탁 드리겠습니다.",
      ],
    },
  },
  {
    question: "한 학교에서 최대 몇명까지 이용이 가능한가요?",
    answer: {
      title: "최대 3명이 이용 가능합니다.",
      content: [
        "한 개 학교에 보건교사는 최대 2명까지 등록 가능하며, 그외 보건 지원강사님까지 최대 3명이 안정적으로 실시간으로 데이터를 주고 받으며 사용가능합니다.",
        "또한 학교를 이동하더라도 '소속변경'을 통해 별도의 자료 백업 없이 간단하고 쉽게 기존에 사용하시던 로켓처방 및 기타 세팅 정보를 유지한 상태로 업무를 계속 보실 수 있습니다.",
      ],
    },
  },
  {
    question: "보건일지를 이관하면 무엇이 좋은가요?",
    answer: {
      title: "과거에 쓰시던 프로그램에서 계속 이어서 기록할 수 있습니다.",
      content: [
        "새로운 프로그램을 사용하는 것은 업무의 연속성 측면에서 부담일 수 있습니다.",
        "하지만 스마일보건은 타 업체의 이관된 일지들 모두 최근방문학생 기록에서 확인할 수 있으며, 통계 또한 연결되어 업무의 연속성을 놓치지 않았습니다.",
        "스마일보건에서 기존의 기록을 연결하여 계속 이어서 업무를 볼 수 있습니다. 지금 바로 이관해보세요.",
      ],
    },
  },
  {
    question: "운영시간이 어떻게 되나요?",
    answer: {
      title: "선생님의 시간과 항상 함께합니다.",
      content: [
        "스마일보건은 주중(월~금) 오전 8시 00분부터 오후 5시 30분까지 열려있습니다.",
        "하단 우측의 상담톡 버튼을 통해서, 전화 또는 채팅으로 언제든지 질의가 가능합니다.",
        "채팅에서는 사진 기능도 제공하고 있어, 궁금하신 부분을 캡쳐하여 보내주시면 더 빠르고 상세한 안내가 가능합니다.",
      ],
    },
  },
  {
    question: "학생들이 많이 올 때 보건일지 추가가 어려워요.",
    answer: {
      title: "네, 그래서 스마일보건이 탄생하게 되었습니다.",
      content: [
        "선생님은 딱 클릭을 3번하시면, AI가 알아서 일지를 작성합니다.",
        "이제 선생님께서도 스마일보건에서 더 편하게 업무를 하시면 되겠습니다.",
      ],
    },
  },
];
